module.exports = __webpack_public_path__ + "static/img/info-3.3df0a42d.png";